/**
 * From https://stackoverflow.com/questions/476436/is-there-a-null-coalescing-operator-in-javascript
 *
 * @deprecated You can now use null operators, e.g. `a ?? b`. Don't use this function.
 */
function coalesce() {
  var len = arguments.length;
  for (var i = 0; i < len; i++) {
    if (arguments[i] !== null && arguments[i] !== undefined) {
      return arguments[i];
    }
  }
  return null;
}

export default coalesce;
